module.exports = __webpack_public_path__ + "img/home-inspections-ongoing.704c66f6.svg";